import React from 'react'

export default ()=>{
    return(
        <style>
            {`
            .below-collapse {
                color: #4187a6;
                font-size: 20px;
                line-height: 27px;
                font-family: red hat Display;
                width: 931px!important;
            }
            `}
        </style>

    );
}